const publicRoutes = [
    {
        path: "/",
        name: "public-homepage",
        component: () => import("../views/public/Home.vue"),
    },
    {
        path: "/inscription",
        name: "public-register",
        component: () => import("../views/public/newAccount/Register.vue"),
    },
    {
        path: "/inscription/approche",
        name: "public-register-approach",
        component: () => import("../views/public/newAccount/Approach.vue"),
    },
    {
        path: "/inscription/conditions",
        name: "public-register-conditions",
        component: () => import("../views/public/newAccount/Conditions.vue"),
    },
    {
        path: "/inscription/succes",
        name: "public-register-success",
        component: () => import("../views/public/newAccount/Success.vue"),
    },
    {
        path: "/me-connecter",
        name: "public-login",
        component: () => import("../views/public/Login.vue"),
    },
    {
        path: "/maintenance",
        name: "public-maintenance",
        component: () => import("../views/public/Maintenance.vue"),
    },
    {
        path: "/mot-de-passe-oublie",
        name: "public-forget-password",
        component: () => import("../views/public/PasswordForgotten.vue"),
    },
    {
        path: "/nouveau-mot-de-passe/:token",
        name: "public-regenerate-password",
        component: () => import("../views/public/RegeneratePassword.vue"),
    },
    {
        path: "/nouvel-email/:token?/:emailFrom/:emailTo",
        name: "public-regenerate-email",
        component: () => import("../views/public/RegenerateEmail.vue"),
    },

    {
        path: "/aide",
        name: "public-help-candidature",
        beforeEnter() {
            location.href = '//apform.fr/jeunes-candidat-asv-gipsa/aide-candidature/'
        }
    },
    {
        path: "/contactez-nous",
        name: "public-help-contact",
        beforeEnter() {
            location.href = '//apform.fr/espace-candidat/contact-candidat/'
        }
    },
    {
        path: "/inscription/aide",
        name: "public-help-inscription",
        beforeEnter() {
            location.href = '//apform.fr/jeunes-candidat-asv-gipsa/aide-candidature/'
        }
    },
    {
        path: "/facebook",
        name: "public-facebook",
        beforeEnter() {
            location.href = '//www.facebook.com/APForm'
        }
    },
    {
        path: "/instagram",
        name: "public-instagram",
        beforeEnter() {
            location.href = '//www.instagram.com/apform_/'
        }
    },
    {
        path: "/linkedin",
        name: "public-linkedin",
        beforeEnter() {
            location.href = '//www.linkedin.com/company/apform/mycompany/'
        }
    },
];
export default publicRoutes;
